import { createSlice } from '@reduxjs/toolkit';
import applicationState from './state';
const applicationSlice = createSlice({
    initialState: applicationState,
    name: 'application',
    reducers: {
        resetApplication: () => applicationState,
        setMobile: state => {
            state.mobile = true;
        }
    }
});
export const { resetApplication, setMobile } = applicationSlice.actions;
export default applicationSlice.reducer;
